"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppTaskMessageType = void 0;
var AppTaskMessageType;
(function (AppTaskMessageType) {
    AppTaskMessageType["DEACTIVATE_PARTICIPANTS"] = "DEACTIVATE_PARTICIPANTS";
    AppTaskMessageType["DELETE_INACTIVE_USERS"] = "DELETE_INACTIVE_USERS";
    AppTaskMessageType["API_PULL"] = "API_PULL";
    AppTaskMessageType["FORM_ACTION"] = "FORM_ACTION";
})(AppTaskMessageType = exports.AppTaskMessageType || (exports.AppTaskMessageType = {}));
//# sourceMappingURL=appTaskMessage.js.map